import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Card, Skeleton } from "antd";

const GeneralInformation = (props) => {
  const { userDetails, hasEditAccess, cardTitleStyle, isLoading } = props;
  return (
    <Card
      data-testid="general-info"
      title={<span style={cardTitleStyle}>General Information</span>}
      bordered={false}
      extra={
        hasEditAccess && userDetails?._id ? (
          <Link to={`/user-create/${userDetails?._id}?step=general`}>Edit</Link>
        ) : null
      }
    >
      {isLoading ? (
        <Skeleton active title={false} paragraph={{ rows: 4 }} />
      ) : (
        <>
          <p>Email Address</p>
          <h4>{userDetails?.email ?? "N/A"}</h4>
          <p>Mobile Number</p>
          <h4>{userDetails?.mobile ?? "N/A"}</h4>
        </>
      )}
    </Card>
  );
};

GeneralInformation.propTypes = {};

export default GeneralInformation;
